import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkDataProductListingForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsLinkDataProductListing = ({
  editable = true,
  forceValidation,
  productListingChange,
  productListingLinkData,
  productListingLinkMetadata,
  productListingValidate,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.productListing.title')}</h3>
    <LinkDataProductListingForm
      editable={editable}
      forceValidation={forceValidation}
      onChange={productListingChange}
      onValidate={productListingValidate}
      productListingLinkData={productListingLinkData}
      productListingLinkMetadata={productListingLinkMetadata}
      shouldIgnoreMandatoryValidation
    />
  </>
);

export default IncidentDetailsLinkDataProductListing;
